export default __webpack_public_path__ + "static/media/embrapii.b413d506.png";